import React from 'react'
import styled from 'styled-components'
import varsityInfo from '../data/varsityInfo'
import Logo from './Logo'
import SocialMenu from './SocialMenu'


const Footer = () => {
    const { fullName, address, contactNo, email, shortDesc } = varsityInfo;
    return (
        <Wrapper>
            <div className='py-4 bg-dark text-light text-center'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 text-start">
                            <Logo />
                            <p className="lead mb-4">{shortDesc}</p>
                            &copy; {new Date().getFullYear()} :: {fullName}
                        </div>

                        <div className="col-lg-6 text-end">
                            <h2 className="mb-4 fw-bolder">Quick Contact</h2>
                            <p className='lead'><i className="fas fa-map-marker"></i> {address}</p>
                            <p className='lead'><i className="fas fa-phone"></i> {contactNo}</p>
                            <p className='lead'><i className="fas fa-envelope"></i> {email[0]}</p>
                            <SocialMenu />
                        </div>
                    </div>
                   
                </div>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.section`

`

export default Footer
